module.exports = __webpack_public_path__ + "static/media/giftCard.cc0b2dea.svg";